import $ from 'jquery'
import { onDocumentEvent } from '@app/utils/domHelpers'

let timeoutId = null

const refreshPollings = () => {
  clearTimeout(timeoutId)

  let shouldRefresh = false

  const pollingElements = document.querySelectorAll(
    "[data-behaviour~='polling']"
  )

  pollingElements.forEach((el) => {
    const shouldContinue = el.dataset.pollingShouldContinue === '1'
    const path = el.dataset.pollingPath

    if (shouldContinue && path) {
      $.getScript(path)

      shouldRefresh = true
    }
  })

  if (shouldRefresh) {
    timeoutId = setTimeout(refreshPollings, 5000)
  }
}

const redirectPostPolling = (e) => {
  const redirectPath = e?.detail?.pollingRedirectPath

  if (redirectPath) {
    Turbolinks.visit(redirectPath)
  }
}

export default () => {
  const removePollingListeners = onDocumentEvent(
    document,
    'turbolinks:load',
    null,
    refreshPollings
  )
  const removeStoppedListener = onDocumentEvent(
    document,
    'polling:stopped',
    null,
    redirectPostPolling
  )

  return () => {
    clearTimeout(timeoutId)
    removePollingListeners()
    removeStoppedListener()
  }
}
